<template>
  <t-modal
    :name="`rental-reject`"
    :variant="`confirmation`"
    :hideCloseButton="true"
    :disableBodyScroll="true"
    :escToClose="!isLoading"
    :clickToClose="!isLoading"
    @closed="onClose"
  >
    <section class="px-4 pt-4 text-2xl font-extrabold text-center">
      Reject Rent Request
    </section>

    <div class="px-5 pt-5">
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(onConfirm())"
          enctype="multipart/form-data"
        >
          <AppInput
            v-model="form.reason"
            type="richselect"
            name="reason"
            label="Reason"
            placeholder="Select a reason"
            text-attribute="text"
            value-attribute="value"
            hide-search-box
            :fetch-options="onFetchReasons"
          />
          <button type="submit" ref="submitButtonRef" class="hidden">
            Confirm
          </button>
        </form>
      </ValidationObserver>
    </div>

    <section
      class="flex items-center justify-end px-4 py-4 mt-6 space-x-5 bg-gray-50"
    >
      <AppButton
        :disabled="isLoading"
        :variant="`secondary`"
        :class="`w-1/2`"
        @click="onClose"
      >
        Close
      </AppButton>

      <AppButton
        :variant="`primary`"
        :class="`w-1/2`"
        :isLoading="isLoading"
        :disabled="isLoading"
        @click="$refs.submitButtonRef.click()"
      >
        Confirm
      </AppButton>
    </section>
  </t-modal>
</template>

<script>
import { xMan } from '@/utils'
import { useEndpoints } from '@/composables'

export default {
  props: {
    rentId: {
      type: String,
      required: true,
    },
  },
  components: {},
  mounted() {
    this.$modal.show('rental-reject')
  },
  data() {
    return {
      isLoading: false,
      form: {
        reason: null,
      },
    }
  },
  methods: {
    async onFetchReasons(query) {
      await this.$http
        .get(useEndpoints.vehicleRental.rejectReasons(), {
          params: {
            search: query,
          },
        })
        .then(({ data }) => {
          this.reasons = data?.map((item) => ({
            text: item.name,
            value: item.value,
          }))
        })
        .catch((err) => {
          console.log('onFetchReasons', err, err.response)
        })

      return { results: this.reasons }
    },
    onClose(shouldUpdate) {
      this.$emit('close', shouldUpdate)
    },
    onConfirm() {
      const self = this
      const form = this.form

      this.isLoading = true

      const formDataProxy = {
        status: 'REJECTED',
      }

      if (form.reason) {
        formDataProxy.reject_reason = form.reason
      }

      const formData = new xMan(formDataProxy).toFormData()

      this.$http
        .patch(useEndpoints.vehicleRental.update(this.rentId), formData)
        .then((res) => {
          console.log(res)

          self.$notify(
            {
              group: 'bottomRight',
              type: 'success',
              title: `Rental Request Cancelled`,
              text: `The rental request has been cancelled successfully`,
            },
            5000
          )
          self.$store.dispatch('fsTable/fetchData')
          self.onClose(true)
        })
        .catch((err) => {
          console.log('onConfirm', err, err.response)
          self.$notify(
            {
              group: 'bottomRight',
              type: 'error',
              title: `Rental Request Update Error`,
              text: `Rental request could not be cancelled`,
            },
            5000
          )
          self.isLoading = false
        })
    },
  },
}
</script>
